module.exports = __webpack_public_path__ + "static/media/expand.0ebd0a23.svg";